// Interaction primitive registry — DECISION-024.
//
// Each primitive registers itself at module import. The composer looks
// up the primitive by name from `manifest.interactions[*].kind` and
// calls its `wire` function once per fixture instance.
//
// Primitives own their own state (lid open/closed, current browse index,
// etc.) and their own teardown via the returned dispose function.

const _registry = new Map();

/**
 * @typedef {Object} InteractionContext
 * @property {Object} anchor          Anchor entry.
 * @property {Object} manifest        Full fixture manifest.
 * @property {Object} interactionDef  The single manifest.interactions[N] entry being wired.
 * @property {Object} bodyMesh        Placed body mesh.
 * @property {Object=} lidMesh        Placed lid mesh (when fixture has one).
 * @property {Object} slotResult      SlotLayoutResult from the slot-layout primitive.
 * @property {Object} stage           The Runtime Stage instance for cross-system hooks (scene graph, dispatcher registration, comic browse APIs, etc.).
 * @property {Object} composedEntry   Mutable object the composer accumulates state into; primitive can attach handles for downstream primitives in the same fixture.
 */

/**
 * Register an interaction primitive.
 * @param {string} name
 * @param {(ctx: InteractionContext) => (() => void) | void} wireFn
 *   Returns an optional dispose function called on fixture teardown.
 */
export function registerInteraction(name, wireFn) {
	if (_registry.has(name)) {
		console.warn(`[interactions] '${name}' already registered; overwriting`);
	}
	_registry.set(name, wireFn);
}

export function getInteraction(name) {
	return _registry.get(name) || null;
}

export function listInteractions() {
	return Array.from(_registry.keys());
}
